import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import {Message} from '@aperza/ui';
import clsx from 'clsx';

import style from './SmallNotificationModal.module.scss';

const SmallNotificationModal = (props) => {

  let {
    open,
    icon,
    messageId
  } = props;

  useEffect(() => {
    console.log("open:",open)
    if(open) {
      $('#smallNotificationModal').fadeIn(400);
    } else {
      $('#smallNotificationModal').fadeOut(1000);
    }
  }, [open]);

  return (
    <React.Fragment>
      <div id="smallNotificationModal" className={style.SmallNotificationModal} style={{'display': 'none' }}>
        { icon &&
          <i className={clsx('fa','fa-'+icon,style.SmallNotificationModalIcon)}></i>
        }
        <Message className={style.SmallNotificationModalText} messageId={messageId} />
      </div>
    </React.Fragment>
  );

};

SmallNotificationModal.propTypes = {
  open: PropTypes.bool,
  icon: PropTypes.string,
  messageId: PropTypes.string
};

export default SmallNotificationModal;
